import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { FieldsStore } from 'stores/fields';

type BillablePatch = {
  defaultTimeEntryBillable: boolean;
};

type CategoryPatch = {
  defaultTimeEntryCategory: number | null;
};

export const useTimeEntryField = (task, onUpdateTask) => {
  const fieldsStore = useSelector(({ fields }: RootState) => fields);

  const [, billableField] = FieldsStore.getTaskFieldByName(
    'defaultTimeEntryBillable',
  )(fieldsStore);
  const [, categoryField] = FieldsStore.getTaskFieldByName(
    'defaultTimeEntryCategory',
  )(fieldsStore);

  const defaultBillable = task.defaultTimeEntryBillable;
  const defaultCategory = task.defaultTimeEntryCategory;

  const onFieldValueChange = (patch: BillablePatch | CategoryPatch) => {
    onUpdateTask({
      defaultTimeEntryBillable: task.defaultTimeEntryBillable,
      defaultTimeEntryCategory: task.defaultTimeEntryCategory,
      ...patch,
    });
  };

  return {
    billableField,
    categoryField,
    defaultBillable,
    defaultCategory,
    onFieldValueChange,
  };
};
